export default __webpack_public_path__ + "static/network-06623435a7efb452ebb309f9d66a8d29.png";